import React from "react";
import styled from "@emotion/styled";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet";

import DynamicComponentLoader from "../components/DynamicComponent";

export default function Community({ isSmall, ...props }) {
  const { Content } = props?.data;

  // useEffect(() => {
  //   console.log(props);
  // }, [props]);

  return (
    <Wrapper disableGutters align="center" maxWidth={"false"}>
      <Helmet>
        <title itemProp="name" lang="en">
          The Kahanoff Centre – Community
        </title>
      </Helmet>
      {Content?.map((block, index) => {
        return (
          <DynamicComponentLoader
            key={block.Copy}
            isSmall={isSmall}
            theme={props?.theme}
            {...block}
          />
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled(Container)`
  a.button {
    background-color: ${props => props.theme.palette.common.white};
    color: ${props => props.theme.palette.common.black};
    &:hover {
      background-color: ${props => props.theme.palette.primary.main};
      color: ${props => props.theme.palette.common.white};
    }
  }
`;
